import PropTypes from 'prop-types'
import React from 'react'
import { owlAddError, owlAddLog, loganReport } from '../../utils/owl'

class ErrorBoundary extends React.Component {
  state = {
    hasError: false,
    error: null,
  }

  componentDidCatch (error, errorInfo) {
    const e = { error, ...errorInfo }
    console.log('ErrorBoundary Catch:', e.componentStack)
    // 自定义处理
    this.props.onError && this.props.onError(e)
    // owlAddError(JSON.stringify(e))
    owlAddError(new Error(JSON.stringify({ ...error, ...errorInfo })), { category: 'errorBoundary', level: 'warn' })
    owlAddLog(JSON.stringify(e))
    loganReport()
  }

  // 从错误中映射状态对象
  static getDerivedStateFromError (error) {
    return {
      hasError: true,
      error,
    }
  }

  render () {
    if (this.state.hasError) {
      return this.props.fallback
    }
    return this.props.children
  }
}

ErrorBoundary.propTypes = {
  fallback: PropTypes.node,
  onError: PropTypes.func,
  children: PropTypes.element,
}
export default ErrorBoundary
